import { render, staticRenderFns } from "./VsLogoLoader.vue?vue&type=template&id=230334bc&lang=pug&"
import script from "./VsLogoLoader.vue?vue&type=script&lang=js&"
export * from "./VsLogoLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('230334bc')) {
      api.createRecord('230334bc', component.options)
    } else {
      api.reload('230334bc', component.options)
    }
    module.hot.accept("./VsLogoLoader.vue?vue&type=template&id=230334bc&lang=pug&", function () {
      api.rerender('230334bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsLogoLoader.vue"
export default component.exports